import { createContext } from 'react';

export type BehaviourContextType = {
  toggleChat: () => void;
};

export const BehaviourContext = createContext<BehaviourContextType>({} as BehaviourContextType);

BehaviourContext.displayName = 'BehaviourContext';
